export const featureFlags = {
  specialCircumstances: false,
  panoramaPreview: true,
  ifcUpload: true,
  isDev: import.meta.env.VITE_ENV === "development",
};
